import React from "react";
import "./Navbar.css";
import "../Pages/Download/Download";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <div className="navbar">
      <ul className="nav-item">
        <li>
          <Link to="/home">Home</Link>
        </li>
        <div class="dropdown">
          <div class="dropbtn">Corporate</div>
          <div class="dropdown-content">
            <Link to="/about">About Us</Link>
            <hr />
            <Link to="/mission">Mission And Vision</Link>
            <hr />
            <Link to="/milestone">Milestone</Link>
            <hr />
          </div>
        </div>
        <li>
          <Link to="/product">Products</Link>
        </li>
        <li>
          <Link to="/photogalary">Photo Gallery</Link>
        </li>
        {/* <li><a href='#contact'>Resources</a></li> */}
        <div class="dropdown">
          <div class="dropbtn">Resources</div>
          <div class="dropdown-content">
            <Link to="/infrastructure">Infrastructure</Link>
            <hr />
            <Link to="/isocertification">ISO Certification</Link>
            <hr />
            <Link to="/qualitypolicy">Quality Policy</Link>
            <hr />
            <Link to="/safetypolicy">Safety Policy</Link>
            <hr />
            <Link to="#">Overseas Market</Link>
            <hr />
          </div>
        </div>
        <li>
          <Link to="/career">Careers</Link>
        </li>
        {/* <li><a href='#contact'>CSR</a></li> */}
        <div class="dropdown">
          <div class="dropbtn">CSR</div>
          <div class="dropdown-content">
            <Link to="/csr">Blood Donation Camp</Link>
          </div>
        </div>
        {/* <li><a href='#contact'>Application Videos</a></li> */}
        <div class="dropdown">
          <div class="dropbtn">Application Videos</div>
          <div class="dropdown-content">
            <Link to="/sugar">Sugar Industry Application</Link>
            <hr />
            <Link to="/steel">Steel Industry Chain Application</Link>
            <hr />
            <Link to="/cement">Cement Chain Application</Link>
            <hr />
            <Link to="/chemical">Chemical & Fertilizer Application</Link>
            <hr />
          </div>
        </div>
        <li>
          <Link to="/feedback">Feedback</Link>
        </li>
        <li>
          <Link to="/download">Download</Link>
        </li>
        <li>
          <Link to="/contact">Contact Us</Link>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
